import NodeContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content/node.js';

import { dasherize } from '@ember/string';

import uiPageConfig from 'rise-ui/config/ui-page.js';
import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

/**
 * Serializer for ember-data requests to data-admin server static block content
 */
@keyForAttribute({
  location: uiPageConfig.locationField,
})
export default class UiPageSerializer extends NodeContentApiSerializer {
  extractId(modelClass, resourceHash) {
    return dasherize(resourceHash.attributes?.field_static_block_location)
      || super.extractId(...arguments);
  }
}
